<template>
  <div class="collection-view new-view-layout">
    <!-- <error-view v-if="hasError" module="message"/>
    <template v-else> -->
      <van-loading v-if="isFetching" color="black" />
      <div class="collection-detail" v-if="!isFetching">
        <message-card :info="collectionDesc">
          <template slot="title">
            <div class="title" >
              <img src="@/assets/embedAppPageImg/collection-icon.svg"/>
              <span>{{collectionInfo.name}}</span>
            </div>
          </template>
          <template slot="status">
            <div class="collection-current-status">
              <img :src="getCollectionStatue()"/>
            </div>
          </template>
        </message-card>
        <div class="upload-status" v-if="$route.query.uploadSuccess">
          <img src="@/assets/embedAppPageImg/submitSuccess.svg"/>
          <p>提交成功</p>
        </div>
      </div>
      <collection-form :collectionInfo="collectionInfo" @uploaded-file="getUploadedFile"/>
    <!-- </template> -->
    <van-popup
      class="collection-sumbit"
      v-model="collectionSumbitShow"
      position="right"
    >
      <collection-submit
        :collectionInfo="collectionInfo"
        :uploadedFile = "uploadedFile"
      />
    </van-popup>

  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import ajax from '@/utils/ajax'
import CollectionForm from './CollectionForm'
import {GET_COLLECTION_INFO} from '@/config/api'
import {formatDate} from '@/utils/common'
import CollectionSubmit from './CollectionSubmit'
import MessageCard from '../components/MessageCard'

export default {
  name: 'CollectionView',
  components: {
    CollectionForm,
    CollectionSubmit,
    MessageCard
  },
  i18n,
  props: {
  },
  data () {
    return {
      collectionInfo: {},
      name_rules: new Map(),
      collectionSumbitShow: false,
      uploadedFile: [],
      isFetching: false
    }
  },
  computed: {
    collectionDesc () {
      const { user, created, description } = this.collectionInfo
      return [{
        'label': '发起人',
        'text': user && user.name
      }, {
        'label': '发起时间',
        'text': formatDate(created * 1000, '%YY-%MM-%DD')
      }, {
        'label': '收集描述',
        'text': description
      }]
    }
  },
  beforeCreate () {
    this.$router.replace({ query: {} })
  },
  created () {
    console.log('this.$router', this.$route)
    document.title = '收集详情'
    this.fetchCollectionInfo()
  },
  watch: {
    $route (to, from) {
      this.collectionSumbitShow = !!to.query.collectionSumbitShow
    }
  },
  methods: {
    getCollectionStatue () {
      if (!this.collectionInfo.is_valid) {
        // 已失效
        return require('@/assets/embedAppPageImg/valid.svg')
      } else if (this.collectionInfo.is_closed || this.collectionInfo.is_expired) {
        // 已截止
        return require('@/assets/embedAppPageImg/expired.svg')
      } else {
        // 进行中
        return require('@/assets/embedAppPageImg/pending.svg')
      }
    },
    createTime (time) {
      return formatDate(time * 1000, '%YY-%MM-%DD')
    },
    fetchCollectionInfo () {
      this.isFetching = true
      ajax({
        url: `${GET_COLLECTION_INFO}?id=${this.$route.params.id}`
      }).then(res => {
        if (res && res.success) {
          this.collectionInfo = res.process
        }
        this.isFetching = false
      })
    },
    getUploadedFile (file) {
      this.$router.push({ query: {collectionSumbitShow: 1} })
      this.uploadedFile = file
    }
  }
}
</script>

<style  lang="postcss">
@import 'variables';

.collection-view {
  & .collection-sumbit {
    height: 100%;
    width: 100%;
    background: var(--newPageBgColor);
  }

  & .collection-detail {
    & .message-card {
      & .title {
        border-bottom: 0.5px solid #EBF0F5;

        & img {
          display: flex;
          width: 32px;
          height: 32px;
          margin-right: 16px;
        }

        & span {
          display: flex;
          width: 185px;
        }
      }

      & .collection-info {
        padding-top: 12px;
        & .file-name {
          color: var(--fontBasicColor);
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 2px;
        }
        & .size {
          color: #626F84;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          margin-bottom: 2px;
        }

        & .file-path {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          color: #626F84;
          & span {
            color: var(--btnPrimaryColor);
          }
        }
      }

      & .collection-item {
        display: flex;
        color: #9BA7BA;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        min-height: 18px;
        margin-bottom: 4px;
        & label {
          display: flex;
          min-width: 48px;
          width: 48px;
          margin-right: 20px;
          color: #9BA7BA;
        }
        & span {
          display: flex;
          color: #626F84;
          word-wrap: break-word;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }

      & .collection-current-status {
        width: 104px;
        height: 104px;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #fff;
        & svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    & .upload-status {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      & img {
        width: 220px;
        height: 150px;
      }
      & p {
        color: #2A2B33;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
</style>
